define('vspot-angular/services/waitlist-service',['angular'], function (ng) {
    'use strict';

    return ['resources.Waitlist', function (Waitlist) {

        return {

            /**
             * create_activity_waitlist:
             *
             * @param {int} activityId - the activity_id used for entrance (through invitation or link)
             * @param {str} accessKey - accesskey for user - used for verification
             */
            createActivityWaitlist: function(activityId, accessKey) {
                return Waitlist.create_activity_waitlist({
                    activity_id:        activityId,
                    accesskey:          accessKey,
                    doitall:            true
                });
            },

            createEventWaitlist: function(activityId, eventId, accessKey) {
                return Waitlist.create_event_waitlist({
                    activity_id:        activityId,
                    event_id:           eventId,
                    accesskey:          accessKey
                });
            },

            createJobWaitlist: function(activityId, jobId, accessKey) {
                return Waitlist.create_job_waitlist({
                    activity_id:        activityId,
                    job_id:             jobId,
                    accesskey:          accessKey
                });
            },

            deleteActivityWaitlist: function(activityId, accessKey) {
                return Waitlist.delete_activity_waitlist({
                    activity_id:        activityId,
                    accesskey:          accessKey,
                    doitall:            true
                });
            },

            deleteEventWaitlist: function(activityId, eventId, accessKey) {
                return Waitlist.delete_event_waitlist({
                    activity_id:        activityId,
                    event_id:           eventId,
                    accesskey:          accessKey
                });
            },

            deleteJobWaitlist: function(activityId, jobId, accessKey) {
                return Waitlist.delete_job_waitlist({
                    activity_id:        activityId,
                    job_id:             jobId,
                    accesskey:          accessKey
                });
            },
            myWaitlists: function(activityId, accessKey) {
                return Waitlist.my_waitlists({
                    activity_id:        activityId,
                    accesskey:          accessKey
                });
            },

        };
    }];
});

